export const mentionStyles = {
	control: {
		backgroundColor: '#fff',
		fontSize: 16,
		borderRadius: 8,
		border: '1px solid #ccc',
	},

	'&multiLine': {
		control: {
			fontFamily: "'Public Sans', sans-serif",
			fontWeight: 300,
			fontSize: 16,
			lineHeight: '18px',
			minHeight: 120,
			borderRadius: 8,
		},
		highlighter: {
			padding: 9,
			border: '1px solid transparent',
			borderRadius: 8,
		},
		input: {
			padding: 9,
			border: '1px solid #ededed',
			borderRadius: 8,
			minHeight: 120,
			fontFamily: "'Public Sans', sans-serif",
			fontWeight: 300,
			fontSize: 16,
			lineHeight: '18px',
		},
	},

	'&singleLine': {
		display: 'inline-block',
		width: 180,

		highlighter: {
			padding: 1,
			border: '2px inset transparent',
		},
		input: {
			padding: 1,
			border: '2px inset',
			borderRadius: 8,
		},
	},

	suggestions: {
		list: {
			backgroundColor: '#fff',
			border: '1px solid #e5e7eb',
			borderRadius: 8,
			fontSize: 14,
			overflow: 'hidden',
			boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
			width: 256,
			maxHeight: 192,
			overflowY: 'auto' as const,
		},
		item: {
			padding: '8px 12px',
			display: 'flex',
			alignItems: 'center',
			gap: 8,
			cursor: 'pointer',
		},
		itemFocused: {
			backgroundColor: '#f9fafb',
		},
	},
};

export const mentionHighlightStyle = {
	backgroundColor: '#daf4fa',
	display: 'inline',
	padding: '0 2px',
	borderRadius: '4px',
};
